const LEGACY_FONT_AWESOME_BASES = new Set(['fa', 'fas', 'far', 'fab']);

/**
 * Completa la classe base delle PrimeIcons e mantiene compatibili le icone
 * Font Awesome provenienti dal catalogo /suite o dai dashboard persistiti.
 * I glifi legacy non vengono tradotti: una conversione parziale cambierebbe
 * l'identita visiva dei valori data-driven e perderebbe i modifier originali.
 */
export function normalizePrimeIconClass(value: unknown): string {
  const source = typeof value === 'string' ? value.trim() : '';
  if (!source) {
    return 'pi pi-circle';
  }

  const tokens = source.split(/\s+/u);
  const hasLegacyFontAwesomeClass = tokens.some(token => token.startsWith('fa-'));

  if (hasLegacyFontAwesomeClass) {
    let legacyBasePresent = false;
    const result = tokens.map(token => {
      if (!LEGACY_FONT_AWESOME_BASES.has(token)) {
        return token;
      }

      if (legacyBasePresent) {
        return '';
      }

      legacyBasePresent = true;
      return 'fa';
    }).filter(Boolean);

    if (!legacyBasePresent) {
      result.unshift('fa');
    }

    return [...new Set(result)].join(' ');
  }

  const primeGlyphPresent = tokens.some(token => token.startsWith('pi-'));
  if (primeGlyphPresent && !tokens.includes('pi')) {
    tokens.unshift('pi');
  }

  return [...new Set(tokens)].join(' ');
}
